import type { TwelveMonthExpenseTrendDTO } from "../models/twelveMonthExpenseTrendDto";
import type {
  TwelveMonthExpenseTrendEntity,
  TwelveMonthExpenseTrendVariant,
} from "../../domain/entities/TwelveMonthExpenseTrendEntity";

const VALID_VARIANTS: TwelveMonthExpenseTrendVariant[] = [
  "within_range",
  "elevated",
  "spike",
];

function mapVariant(v: string): TwelveMonthExpenseTrendVariant {
  return VALID_VARIANTS.includes(v as TwelveMonthExpenseTrendVariant)
    ? (v as TwelveMonthExpenseTrendVariant)
    : "within_range";
}

export function twelveMonthExpenseTrendDtoToEntity(
  dto: TwelveMonthExpenseTrendDTO
): TwelveMonthExpenseTrendEntity {
  return {
    labels: Array.isArray(dto.labels) ? dto.labels.map(String) : [],
    values: Array.isArray(dto.values) ? dto.values.map((v) => Number(v) || 0) : [],
    variants: Array.isArray(dto.variants)
      ? dto.variants.map(mapVariant)
      : [],
    averageExpense: Number(dto.averageExpense) || 0,
    rangeLabel: typeof dto.rangeLabel === "string" ? dto.rangeLabel : "",
    monthCount:
      typeof dto.monthCount === "number" && Number.isFinite(dto.monthCount)
        ? Math.max(0, Math.floor(dto.monthCount))
        : Array.isArray(dto.labels)
          ? dto.labels.length
          : 0,
  };
}
